import { Button } from '@/global/components/Button'
import CircularProgress from '@/global/components/CircularProgress'
import { cn } from '@/lib/utils'
import React from 'react'

import { RootContext } from './DialogGuideRoot'
import { useSetInternalProps } from './utils'

type ButtonProps = React.ComponentProps<typeof Button>

interface ActionsProps extends React.ComponentProps<'div'> {
    children?: React.ReactNode
}

/** Linha de ações do MUI: alinhada à direita, com 8px de respiro. */
function ActionsRoot({ children, className, ...props }: ActionsProps) {
    return (
        <div
            className={cn(
                'flex shrink-0 flex-wrap items-center justify-end gap-2 p-2',
                className,
            )}
            {...props}
        >
            {children}
        </div>
    )
}

interface PrimaryButtonProps extends ButtonProps {
    closeOnSubmit?: boolean
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
    children,
    closeOnSubmit,
    ...props
}) => {
    useSetInternalProps({ closeOnSubmit })

    return (
        <RootContext.Consumer>
            {({ loading, onSubmit, methods }) =>
                // Com `onClick` próprio o botão faz outra coisa que não
                // enviar — é o caso do "Excluir", que abre a confirmação.
                onSubmit || props.onClick ? (
                    <Button
                        data-testid="dialog-primary-button"
                        onClick={() => {
                            if (onSubmit) methods.handleSubmit(onSubmit)()
                        }}
                        disabled={loading || props.disabled}
                        startIcon={
                            loading ? (
                                <CircularProgress size={20} />
                            ) : (
                                props.startIcon
                            )
                        }
                        {...props}
                    >
                        {children || 'Salvar'}
                    </Button>
                ) : null
            }
        </RootContext.Consumer>
    )
}

const SecondaryButton: React.FC<ButtonProps> = ({ children, ...props }) => {
    return (
        <RootContext.Consumer>
            {({ loading, onClose }) => (
                <Button
                    datatype="dialog-secondary-button"
                    onClick={onClose}
                    disabled={loading}
                    variant="text"
                    {...props}
                >
                    {children || 'Cancelar'}
                </Button>
            )}
        </RootContext.Consumer>
    )
}

ActionsRoot.PrimaryButton = PrimaryButton
ActionsRoot.SecondaryButton = SecondaryButton

export { ActionsRoot as Actions }
